import React from "react"
import { PostOwner } from "@fider/models"

// Left-border color for a post card — undefined (no border) when owner is
// unset or its row was deleted since the post was assigned to it.
export const ownerBorderColor = (owner: string, owners: PostOwner[]): string | undefined => {
  return owners.find((o) => o.slug === owner)?.color
}

// Icon + owner name, rendered next to the estimated timeframe. Shows the
// name as plain visible text (not just a hover tooltip) since a color-only
// left border isn't distinctive enough on its own. Renders nothing when
// owner is unset or unresolved (e.g. its row was deleted since assignment).
export const OwnerIcon = (props: { owner: string; owners: PostOwner[] }) => {
  const meta = props.owners.find((o) => o.slug === props.owner)
  if (!meta) {
    return null
  }

  return (
    <span title={meta.name} className="c-owner-icon">
      {meta.icon ? `${meta.icon} ` : ""}
      {meta.name}
    </span>
  )
}
